import { useEffect, useState } from 'react';
import { useNCZIContext } from '../Services/NCZIContext';
import useNCZICommands from './useNCZICommands';
import { FinishedCommand } from '../Commands/Command';
import {
	GetPatientElectronicPrescriptionMedication,
	GetPatientElectronicPrescriptionMedicationParams
} from '../Commands/GetPatientElectronicPrescriptionMedication';

export default function useNCZIElectronicPrescriptionMedication() {
	const {
		patientElectronicPrescriptionMedicationData,
		setPatientElectronicPrescriptionMedicationData,
		patientBirthNumber,
		patientInsurance
	} = useNCZIContext();

	const { commands, execute } = useNCZICommands();

	const [
		listElectronicPrescriptionMedicationCommandId,
		setListElectronicPrescriptionMedicationCommandId,
	] = useState<string | undefined>(undefined);
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(
		undefined,
	);

	const fetchPatientElectronicPrescriptionMedicationData = async (
		params: GetPatientElectronicPrescriptionMedicationParams,
	) => {
		const command = await obtainPatientElectronicPrescriptionMedicationData(params);
		setPatientElectronicPrescriptionMedicationData(null);
		return command;
	};

	useEffect(() => {
		if (
			listElectronicPrescriptionMedicationCommandId &&
			!patientElectronicPrescriptionMedicationData
		) {
			const command = commands[listElectronicPrescriptionMedicationCommandId];
			if (command && command.state === 'done') {
				const finishedCommand = command as FinishedCommand;
				if (finishedCommand.result) {
					console.log({d: finishedCommand.data});
					setPatientElectronicPrescriptionMedicationData(finishedCommand.result);
				}
			}
		}
	}, [commands, listElectronicPrescriptionMedicationCommandId]);

	const obtainPatientElectronicPrescriptionMedicationData = async (
		params: GetPatientElectronicPrescriptionMedicationParams,
	) => {
		const commandGetPatientElectronicPrescriptionMedication =
			GetPatientElectronicPrescriptionMedication(params);

		const result = await execute(commandGetPatientElectronicPrescriptionMedication);
		if (!('error' in result && result.error)) {
			setListElectronicPrescriptionMedicationCommandId(result.id);
		}

		return result;
	};

	const handleLoadPatientElectronicPrescriptionMedicationData = async () => {
		if (patientBirthNumber && patientInsurance) {
			const command = await fetchPatientElectronicPrescriptionMedicationData({
				birthNumber: patientBirthNumber,
				insurance: patientInsurance
			});
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	return {
		handleLoadPatientElectronicPrescriptionMedicationData,
		loadingCommandId,
	};
}
